import { render } from "./zjdList.vue?vue&type=template&id=bbf7ff74&scoped=true"
import script from "./zjdList.vue?vue&type=script&lang=js"
export * from "./zjdList.vue?vue&type=script&lang=js"

import "./zjdList.vue?vue&type=style&index=0&id=bbf7ff74&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf7ff74"]])

export default __exports__